import React, { useEffect, useState } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth';
import { useParams } from 'react-router-dom';
import { Col, Row } from 'reactstrap'
import { auth } from '../../firebase/firebase-config';
import Archive_icon from './Archive_icon';
import Markread from './Markread';
import firebase from '../../firebase/firebase-config';

const ViewFeedback = () => {
    const params = useParams();

    const [user, loading] = useAuthState(auth);
    const [feedback_data, setfeedback_data] = useState({});
    const [mydate, setdate] = useState()

    useEffect(() => {
        GetMyUser();


    }, [])
    async function GetMyUser() {
        try {

            firebase.firestore().collection('feedBack').doc(params.id).onSnapshot((snapshot) => {

                const dates = new Date(snapshot.data()['createdOnDate']);

                setdate(dates.toUTCString());
                setfeedback_data(snapshot.data());

            })

        } catch (error) {
            console.log(error);
        }



    }
    const getDate = () => {

    }


    function printDiv() {
        var divContents = document.getElementById("Email_data").innerHTML;
        var a = window.open('', '', 'height=800, width=800');
        a.document.write('<html>');
        a.document.write('<body >');
        a.document.write(divContents);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    }

    return (
        <>
            <div className="content">

                <div className=" shadow-lg   my-2" style={{ borderRadius: '12px' }} id='Email_data'>
                    <Row>
                        <Col xs="10">


                            <div className="d-flex p-3  justify-content-between  align-items-center " style={{ borderRadius: '12px' }} >

                                <h5 className="font-weight-bolder display-4  "  >Subject: {feedback_data.subject} </h5>
                            </div>
                        </Col>
                        <Col xs='2' className='d-flex flex-row-reverse '>


                            <div className="d-flex p-3 justify-content-end align-items-center  " style={{ width: '100px', zIndex: 25 }}>

                                <div className="px-2" onClick={(e) => {

                                    printDiv()

                                }} style={{ cursor: 'pointer' }} >
                                    <Archive_icon width='1.5em' height='1.5em' />
                                </div>

                                <i className="tim-icons icon-trash-simple px-2" onClick={(e) => {
                                    console.log('delete clicked');
                                }} style={{ cursor: 'pointer' }} />
                                <div className="px-2" onClick={(e) => {
                                    console.log('markRead clicked');
                                }} style={{ cursor: 'pointer' }}>
                                    <Markread />
                                </div>
                            </div>
                        </Col>

                    </Row>
                    <Row>
                        <Col xs='12'>
                            <div className='d-flex p-3 justify-content-between'>


                                <div className='d-flex'>
                                    <div className="author">


                                        <div onClick={(e) => e.preventDefault()} style={{ height: '50px', width: '50px' }}>
                                            <img
                                                alt="..."

                                                style={{ borderRadius: '200px', width: '100%', height: '100%' }}
                                                src='https://firebasestorage.googleapis.com/v0/b/mystory-app-9a032.appspot.com/o/images%2Fplace_holder.png?alt=media&token=6ce47f9d-9ad3-484e-b445-f78676957dc3'
                                            />
                                        </div>

                                    </div>
                                    <div className="px-2">
                                        <p className="font-weight-bolder display-5">{feedback_data.email}</p>
                                        <p className="mt-0 pt-0  ">to Beyown Feedback</p>
                                    </div>

                                </div>
                                <div>

                                    <p>{mydate}</p>
                                </div>
                            </div>
                        </Col>


                    </Row>
                    <Row className='mt-2 mx-4  p-3'>
                        <Col xs='12'>
                            <p className='font-weight-bolder display-4'>Message:</p>
                            <p className='py-4'>{feedback_data.message}</p>
                            <p className='font-weight-bolder '>Regards,</p>
                            <p className=''>{feedback_data.email}</p>
                        </Col>


                    </Row>


                </div>

            </div>

        </>
    )
}

export default ViewFeedback